<template>
  <b-alert show variant="primary" id="sta-no-groups">
    You are not an Administrator <span v-if="includeManager">or Manager</span> for any groups.
    You must create at least one Enterprise Directory group through the
    <a href="https://vt4help.service-now.com/sp?id=sc_cat_item&sys_id=0d029a530fee9b00e42e4b9ce1050ebc"
       target="_blank"
       rel="noopener noreferrer nofollow"
       class="alert-link">
      VT 4Help service catalog
      <font-awesome-icon icon="external-link-alt"></font-awesome-icon>
    </a> or be granted an Administrator <span v-if="includeManager">or Manager</span> role of an existing group.
  </b-alert>
</template>

<script>
export default {
  name: 'NoManagedGroupsAlert',
  props: {
    includeManager: {
      type: Boolean,
      required: false,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/NoAdministeredGroupsAlert.vue